import React from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Outlet } from 'react-router-dom'
import { STUDIO_LOAD_BG } from '../components/StudioLoadingVeil'

const Root = styled(Box)({
  height: '100vh',
  width: '100%',
  overflow: 'hidden',
  // Match StudioLoadingVeil — never use night-canvas (#0e0d12) here; it fringes.
  backgroundColor: STUDIO_LOAD_BG,
  color: 'var(--ds-night-ink)',
  fontFamily: 'var(--ds-font)',
})

/** Full-bleed dark shell for the experimental Studio 3D — unlinked route, see routes.tsx. */
export function Studio3DLayout() {
  return (
    <Root>
      <Outlet />
    </Root>
  )
}
